import { createPinia } from 'pinia';
import { createPersistedState } from 'pinia-plugin-persistedstate';
import type { App } from 'vue';

const pinia = createPinia();

export function setupPinia(app: App) {
  const persistedState = createPersistedState({
    storage: sessionStorage,
  });

  pinia.use(persistedState);
  app.use(pinia);
}

export default pinia;
